import React from 'react'
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Form,
  Input,
  Label,
  Row,
  Col,
} from 'reactstrap'
import { AddressData } from '../../types'

interface AddressInformationProps {
  address: AddressData
  onFieldChange: (field: string, value: string) => void
  disabled?: boolean
}

const AddressInformation: React.FC<AddressInformationProps> = ({
  address,
  onFieldChange,
  disabled = false,
}) => {
  return (
    <Card className="mb-4">
      <CardHeader>
        <CardTitle className="h5 mb-0">Address Information</CardTitle>
      </CardHeader>
      <CardBody>
        <Form>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="address-name-number">
                  Building Name/Number
                </Label>
                <Input
                  type="text"
                  id="address-name-number"
                  value={address.nameOrNumber}
                  onChange={(e) =>
                    onFieldChange('address.nameOrNumber', e.target.value)
                  }
                  disabled={disabled}
                  placeholder="Building name or number"
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="address-street">
                  Street Address <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  id="address-street"
                  value={address.street}
                  onChange={(e) =>
                    onFieldChange('address.street', e.target.value)
                  }
                  disabled={disabled}
                  placeholder="Street address"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="address-line2">
                  Address Line 2
                </Label>
                <Input
                  type="text"
                  id="address-line2"
                  value={address.line2}
                  onChange={(e) =>
                    onFieldChange('address.line2', e.target.value)
                  }
                  disabled={disabled}
                  placeholder="Apartment, suite, etc. (optional)"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="address-town">
                  Town/City <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  id="address-town"
                  value={address.town}
                  onChange={(e) =>
                    onFieldChange('address.town', e.target.value)
                  }
                  disabled={disabled}
                  placeholder="Town or city"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="address-state">
                  County/State
                </Label>
                <Input
                  type="text"
                  id="address-state"
                  value={address.state}
                  onChange={(e) =>
                    onFieldChange('address.state', e.target.value)
                  }
                  disabled={disabled}
                  placeholder="County or state"
                />
              </div>
            </Col>
            <Col md={4}>
              <div className="mb-3">
                <Label className="form-label" htmlFor="address-postcode">
                  Postcode <span className="text-danger">*</span>
                </Label>
                <Input
                  type="text"
                  id="address-postcode"
                  value={address.postcode}
                  onChange={(e) =>
                    onFieldChange('address.postcode', e.target.value)
                  }
                  disabled={disabled}
                  placeholder="Postcode"
                />
              </div>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  )
}

export default AddressInformation
